var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.131 1.08037C11.5517 0.753159 12.1408 0.753159 12.5615 1.08037L21.4077 7.96078C21.6915 8.1815 21.8575 8.52087 21.8575 8.88038V19.6925C21.8575 20.5228 21.5276 21.3191 20.9405 21.9063C20.3533 22.4934 19.557 22.8233 18.7267 22.8233H4.96582C4.13548 22.8233 3.33914 22.4934 2.75199 21.9063C2.16485 21.3191 1.83499 20.5228 1.83499 19.6925V8.88038C1.83499 8.52087 2.00097 8.1815 2.28475 7.96078L11.131 1.08037ZM10.0625 20.4933H13.63V12.9941H10.0625V20.4933ZM15.96 20.4933V11.8291C15.96 11.1857 15.4384 10.6641 14.795 10.6641H8.89749C8.25408 10.6641 7.73249 11.1857 7.73249 11.8291V20.4933H4.96582C4.75343 20.4933 4.54974 20.4089 4.39955 20.2587C4.24937 20.1085 4.16499 19.9049 4.16499 19.6925V9.45016L11.8462 3.47585L19.5275 9.45016V19.6925C19.5275 19.9049 19.4431 20.1085 19.2929 20.2587C19.1427 20.4089 18.9391 20.4933 18.7267 20.4933H15.96Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/Home.5c8f239c9778fc2c1113ad829a96ddcd.svg";
export { ForwardRef as ReactComponent };